export const AUTH_URL = window._env_.AUTH_URL;